import React, { useEffect, useState } from "react";
import { getPrivacyPolicy, getSeoByUrl } from "../api/api";
import { Helmet } from "react-helmet-async";

const RefundPolicy = () => {
  const [policy, setPolicy] = useState("");
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchPolicy = async () => {
      const response = await getPrivacyPolicy();
      if (response.status && response.data && response.data.refund_policy) {
        setPolicy(response.data.refund_policy);
      } else {
        setPolicy("<p>Failed to load refund policy.</p>");
      }
    };
    fetchPolicy();
  }, []);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("refund-policy");
        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };
    fetchSeoData();
  }, []);

  return (
    <div className="custom-padding xl-screen-padding pt-80 pb-80 font-lato">
      <Helmet>
        {/* ================= PRIMARY META ================= */}
        <title>
          {seoData.metaTitle || "Refund Policy | Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || "Read Nutrillion's refund and cancellation policy"}
        />

        {seoData.metaKeywords && (
          <meta name="keywords" content={seoData.metaKeywords} />
        )}

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/refund-policy"}
        />

        {/* ================= OPEN GRAPH ================= */}
        <meta property="og:type" content={seoData.ogType || "website"} />
        <meta property="og:title" content={seoData.ogTitle || seoData.metaTitle || "Refund Policy | Nutrillion"} />
        <meta property="og:description" content={seoData.ogDescription || seoData.metaDescription || "Read Nutrillion's refund and cancellation policy"} />
        <meta property="og:url" content={seoData.ogUrl || seoData.canonicalUrl || "https://nutrillion.one/refund-policy"} />
        {seoData.ogImage && (
          <meta property="og:image" content={seoData.ogImage} />
        )}
        <meta property="og:site_name" content="Nutrillion" />

        {/* ================= TWITTER CARD ================= */}
        <meta name="twitter:card" content={seoData.twitterCard || "summary"} />
        <meta name="twitter:title" content={seoData.twitterTitle || seoData.metaTitle || "Refund Policy | Nutrillion"} />
        <meta name="twitter:description" content={seoData.twitterDescription || seoData.metaDescription || "Read Nutrillion's refund and cancellation policy"} />
        {(seoData.twitterImage || seoData.ogImage) && (
          <meta name="twitter:image" content={seoData.twitterImage || seoData.ogImage} />
        )}

        {/* ================= SCHEMA MARKUP ================= */}
        {seoData.schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(
              typeof seoData.schemaMarkup === "string"
                ? JSON.parse(seoData.schemaMarkup)
                : seoData.schemaMarkup
            )}
          </script>
        )}
      </Helmet>
      <div className="policy-content" dangerouslySetInnerHTML={{ __html: policy }} />
    </div>
  );
};

export default RefundPolicy;